<template>
  <ViewWrapper :scroll-steps="scrollSteps" class="global_shock" footer-orientation="vertical">
    <template #header>
      <ScrollFade class="home__usercount" el="h2" :scroll-position="scrollPosition" :min="0">
        <AnimatedNumber class="home__usercount-value" el="div" :value="userCount" />
        <div class="home__usercount-label">{{ $tc('game.joinedUsers', userCount) }}</div>
      </ScrollFade>
    </template>

    <template #footer>
      <InteractionHint
        class="home__scrollhint"
        :label="$t('ui.interactionHint.scroll')"
        icon="arrows-down"
        animation-class="moveUpDown"
        :interaction-timeout="2000"
        :interaction-trigger="scrollPosition"
      />
    </template>
  </ViewWrapper>
</template>

<script>
import { gsap, ScrollToPlugin } from 'gsap/all';
import store from '../store';

import AnimatedNumber from '../components/AnimatedNumber';
import ViewWrapper from '../components/ViewWrapper';
import InteractionHint from '../components/InteractionHint';
import ScrollFade from '../components/ScrollFade';

gsap.registerPlugin(ScrollToPlugin);

const SCROLL_STEPS = 1.5;

export default {
  name: 'UsersJoined',

  components: {
    AnimatedNumber,
    ViewWrapper,
    InteractionHint,
    ScrollFade,
  },

  props: {
    scrollPosition: {
      type: Number,
      default: undefined,
    },
  },

  data() {
    return {
      scrollSteps: SCROLL_STEPS,
    };
  },

  beforeRouteEnter(from, to, next) {
    window.scrollTo(0, 0);
    next();
  },

  computed: {
    userCount: () => store.userCount,
  },

  watch: {
    scrollPosition(scrollPosition) {
      store.setGlobeTransitionValue(scrollPosition);

      // Fix, because on my Android device with SCROLL_STEPS 1.5 scrollPosition maximum is 0.46
      if (scrollPosition >= SCROLL_STEPS - 1.08) {
        this.$router.replace({ name: 'location' });
      }
    },

    scrollDown() {
      gsap.to(window, { duration: 2.5, scrollTo: { y: 'max' } });
    },
  },
};
</script>

<style lang="scss" scoped>
.home__usercount {
  margin-top: 15%;
  max-width: 320px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}

.home__usercount-value {
  font-size: 35px;
}

.home__usercount-label {
  font-size: 25px;
  font-weight: normal;
}

.home__scrollhint {
  margin-bottom: calc(20px + env(safe-area-inset-bottom));
}
</style>
